/**
 * This file contains some cinema IDs that are used in multiple places.
 */
/** */

export const ID_LUXOR_FILMPALAST_BENSHEIM = 416;
export const ID_LUXOR_FILMPALAST_SCHWETZINGEN = 511;
export const ID_LICHTBLICK_HEIDE = 581;
export const ID_LUXOR_FILMPALAST_NIDDERAU = 1012;
export const ID_LUXOR_FILMPALAST_WALLDORF = 1045;
export const ID_LUXOR_FILMPALAST_HEIDELBERG = 1222;
export const ID_TRAUMPALAST_BACKNANG = 655;
export const ID_TRAUMPALAST_NUERTINGEN = 748;
export const ID_TRAUMPALAST_SCHORNDORF = 769;
export const ID_TRAUMPALAST_WAIBLINGEN = 790;
export const ID_TRAUMPALAST_ESSLINGEN = 969;
export const ID_TRAUMPALAST_LEONBERG = 1193;
export const ID_TRAUMPALAST_SCHWAEBISCH_GMUEND = 1753;
export const ID_KINOPARK_AALEN = 646;
export const ID_KINO_REGINA_ELLWANGEN = 679;
export const ID_KINO_CENTER_HEIDENHEIM = 696;
export const ID_CAPITOL_HEIDENHEIM = 1421;
export const ID_CAPITOL_BLB = 2979;
export const ID_SCHANZENKINO_OPEN_AIR = 1344;
export const ID_KINOSOMMER_VILLACH = 2988;
export const ID_OPEN_AIR_KINO_LANGEN = 2992;
export const ID_OPEN_AIR_KINO_IM_WILDPARK_BAD_MERGENTHEIM = 2994;
export const ID_OPEN_AIR_KINO_AUF_DEM_SCHLOSSBERG_BOXBERG = 2995;
export const ID_INNENSTADT_KINOS = 778;
export const ID_CINEMOON = 63;
export const ID_CINEWORLD_RECKLINGHAUSEN = 877;
export const ID_UFA_DUESSELDORF = 824;
export const ID_CINETECH_EMSDETTEN = 213;
export const ID_CINETECH_AHAUS = 336;
export const ID_CINETECH_GRONAU = 365;
export const ID_CINETECH_RHEINE = 395;
export const ID_APOLLO_KINO = 374;
export const ID_KINO_FREISTADT = 1457;
export const ID_ALPENFILMTHEATER_FUESSEN = 684;
export const ID_CINCINATTI_MUNCHEN = 727;
export const ID_KINOLA = 1653;
export const ID_KINO_ASTORIA = 1070;
export const ID_KINO_SOLOTHURN = 1609;
export const ID_KINO_SAULGAU = 767;
export const ID_KINO_EHINGEN = 677;
export const ID_BELLARIA_KINO = 3000;
export const ID_STUDIO_KINO_RATINGEN = 813;
export const ID_WIED_SCALA_PROGRAMMKINO_CAFE = 390;
export const ID_WELTSPIEGEL_KINO_METTMANN = 387;
export const ID_MOZARTKINO = 1757;
export const ID_PRESTIGE = 469;
export const ID_KINO_BERCHTESGADEN = 999;
export const ID_UNIVERSUM_CITY = 104;
